import React from "react";
import { Typography, Box, Grid, Button } from "@mui/material";
import "./hobbies.css";

const Hobbies = ({ nextStep, prevStep }) => {
  return (
    <Box className='hobbies-container'>
      <Box className='right-flower-character'>
        <img src='./CYPImages/boygirl.png' alt='right-flower character' className='right-flower-character-image' />
      </Box>
      <Box className='hobbies-info-container'>
        {/* Title */}
        <Typography variant='h4' className='hobbies-title' align='center' gutterBottom>
          Hobbies
        </Typography>

        {/* Description */}
        <Typography variant='body1' className='description' align='left' gutterBottom ml={5}>
          The adults in Little Norway will support you to participate in a range <br /> of hobbies and activities. You
          will be required to complete a weekly <br />
          activity planner with staff. This is to ensure activities offered are <br />
          what interests you.
          <br />
          We encourage all young people to get exercise through activities to <br />
          support a healthy lifestyle.
        </Typography>

        {/* Hobbies Grid */}
        <Grid container className='hobbies-grid' spacing={5} justifyContent='center' mt={4}>
          <Grid item>
            <Typography variant='h4' className='hobby swimming' mt={2}>
              Swimming
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant='h4' className='hobby trampolining' mt={5} ml={4}>
              Trampolining
            </Typography>
          </Grid>
        </Grid>
        <Grid container className='hobbies-grid' spacing={5} justifyContent='center'>
          <Grid item>
            <Typography variant='h4' className='hobby gaming' align='center' mt={2}>
              Gaming Clubs
            </Typography>
          </Grid>
        </Grid>
        <Grid container className='hobbies-grid' spacing={5} justifyContent='center'>
          <Grid item>
            <Typography variant='h4' className='hobby football' mt={5}>
              Football
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant='h4' className='hobby cooking' mt={4} ml={4}>
              Cooking
            </Typography>
          </Grid>
        </Grid>

        <Grid container className='hobbies-grid' spacing={5} justifyContent='center' mb={2}>
          <Grid item>
            <Typography variant='h4' className='hobby basketball' mt={10}>
              Basket ball
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant='h4' className='hobby rapping' mt={4} ml={4}>
              Rapping
            </Typography>
          </Grid>
        </Grid>

        {/* Description */}
        <Typography variant='body1' className='description' align='left' gutterBottom ml={6}>
          We understand that trying new things can be difficult so the adults <br /> here at Little Norway are always
          willing to support you and are <br />
          always willing to support you and try new things with you.
        </Typography>

        <Grid container justifyContent='center' alignItems='center' spacing={{ xs: 2, md: 4 }}>
          <Grid item xs={12} md={3} lg={4}>
            <Button type='button' variant='contained' color='primary' onClick={prevStep} fullWidth>
              Previous
            </Button>
          </Grid>
          <Grid item xs={12} md={3} lg={4}>
            <Button type='button' variant='contained' color='primary' onClick={nextStep} fullWidth>
              Next
            </Button>
          </Grid>
        </Grid>
      </Box>
      {/* Child Image */}

      <Box className='child-image-container'>
        <img src='./CYPImages/happysmilingchild.png' alt='Child illustration' className='child-image' />
      </Box>
    </Box>
  );
};

export default Hobbies;
